exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".members .column-header {\n  border-top: 2px solid #e3f0f4;\n  padding: 0.5rem 1rem;\n  color: #7091c5; }\n\n.members .member {\n  padding: 0.75rem 1rem;\n  border-top: 2px solid #e3f0f4; }\n  .members .member .item-actions {\n    opacity: 0;\n    transition: all 200ms ease-in; }\n  .members .member:hover {\n    cursor: pointer; }\n    .members .member:hover .item-actions {\n      opacity: 1; }\n  .members .member:hover {\n    background-color: #fcf9f3; }\n  .members .member .name {\n    font-weight: bold; }\n  .members .member .location {\n    color: #898a8e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/members/member-list/member-list.component.scss
// module id = 402
// module chunks = 0